import { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './GridColumn.module.scss';

const GridColumn = forwardRef(
  (
    {
      children,
      className = null,
      col = null,
      colLg = null,
      colMd = null,
      colSm = null,
      colXl = null,
      type = 'div',
      ...rest
    },
    ref
  ) => {
    const Tag = `${type}`;
    const mergeClasses = {
      [styles[`col-12`]]: !col && !colSm && !colMd && !colLg && !colXl,
      [styles[`col-${col}`]]: col,
      [styles[`col-sm-${colSm}`]]: colSm,
      [styles[`col-md-${colMd}`]]: colMd,
      [styles[`col-lg-${colLg}`]]: colLg,
      [styles[`col-xl-${colXl}`]]: colXl,
    };
    return (
      <Tag
        data-testid="component-grid-column"
        className={classNames(mergeClasses, className)}
        {...rest}
        ref={ref}
      >
        {children}
      </Tag>
    );
  }
);

const columnShape = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.bool,
]);

GridColumn.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  col: columnShape,
  colLg: columnShape,
  colMd: columnShape,
  colSm: columnShape,
  colXl: columnShape,
  type: PropTypes.string,
};

GridColumn.displayName = 'GridColumn';

export default GridColumn;
